module.exports = __webpack_public_path__ + "img/ic-info.a74530fe.svg";